import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-scroll";
import Headroom from "react-headroom";
import "./Header.scss";
import StyleContext from "../../contexts/StyleContext";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";

function Header() {
  const { isDark } = useContext(StyleContext);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Prevent body scrolling when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { to: "about", label: "About", icon: "fas fa-user" },
    { to: "skills", label: "Skills", icon: "fas fa-code" },
    { to: "experiences", label: "Experience", icon: "fas fa-briefcase" },
    { to: "projects", label: "Projects", icon: "fas fa-project-diagram" },
    { to: "awards", label: "Awards", icon: "fas fa-trophy" },
    { to: "contact", label: "Contact", icon: "fas fa-envelope" }
  ];

  return (
    <>
      <Headroom
        style={{ position: "fixed", zIndex: 1001 }}
        className={`header-headroom ${isDark ? "dark" : "light"}`}
      >
        <header className={`header ${isScrolled ? "scrolled" : ""}`}>
          <div className="header-container">
            {/* Logo Section */}
            <div className="logo-section">
              <Link to="about" className="logo" onClick={closeMobileMenu}>
                <div className="logo-content">
                  <span className="logo-bracket">&lt;</span>
                  <span className="logo-name">Mohit Lamba</span>
                  <span className="logo-bracket">/&gt;</span>
                </div>
              </Link>
            </div>

            {/* Desktop Navigation */}
            <nav className="desktop-nav">
              <ul className="nav-list">
                {navItems.map((item, index) => (
                  <li key={index} className="nav-item">
                    <Link
                      activeClass="active"
                      to={item.to}
                      spy={true}
                      smooth={true}
                      offset={-80}
                      duration={500}
                      className="nav-link"
                      onClick={closeMobileMenu}
                    >
                      <i className={item.icon}></i>
                      <span>{item.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Right Section */}
            <div className="header-right">
              {/* Theme Toggle */}
              <div className="theme-toggle">
                <ToggleSwitch />
              </div>

              {/* Mobile Menu Button */}
              <button
                className={`mobile-menu-btn ${isMobileMenuOpen ? "active" : ""}`}
                onClick={toggleMobileMenu}
                aria-label="Toggle mobile menu"
              >
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
              </button>
            </div>
          </div>
        </header>
      </Headroom>

      {/* Mobile Navigation Overlay - Outside header for proper z-index */}
      <div className={`mobile-nav-overlay ${isMobileMenuOpen ? "open" : ""}`} onClick={closeMobileMenu}>
        <div className={`mobile-nav ${isMobileMenuOpen ? "open" : ""}`} onClick={(e) => e.stopPropagation()}>
          <ul className="mobile-nav-list">
            {navItems.map((item, index) => (
              <li key={index} className="mobile-nav-item">
                <Link
                  activeClass="active"
                  to={item.to}
                  spy={true}
                  smooth={true}
                  offset={-80}
                  duration={500}
                  className="mobile-nav-link"
                  onClick={closeMobileMenu}
                >
                  <i className={item.icon}></i>
                  <span>{item.label}</span>
                </Link>
              </li>
            ))}
            {/* Theme Toggle in Mobile Menu */}
            <li className="mobile-nav-item mobile-theme-toggle">
              <div className="mobile-nav-link mobile-theme-toggle-wrapper">
                <i className={isDark ? "fas fa-sun" : "fas fa-moon"}></i>
                <span>{isDark ? "Light Mode" : "Dark Mode"}</span>
                <ToggleSwitch />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Header;
